import React from "react";
import ShareIcon from "../../../assets/img/ShareIcon.svg";
import GradientProfile from "../../shared/GradientProfile";
import classNames from "classnames";
import { Tribe, TribeUser } from "../../../types/tribes.types";

interface EventBannerProps {
  tribes?: Tribe[];
  bannerImage: string;
}

const EventBanner: React.FC<EventBannerProps> = ({ tribes, bannerImage }) => {
  return (
    <>
      <div className="hero_banner_slider event_banner">
        <div className="hero_banner_slider_video">
          <img
            src={bannerImage}
            alt="banner"
            className="w-full h-full object-cover"
          />

          <div className="absolute bottom-4 left-4 flex flex-col gap-1 bg-black/40 backdrop-blur-sm rounded-lg px-3 py-2">
            <div className="flex items-center gap-2.5">
              <div className="flex -space-x-3">
                {tribes
                  ?.flatMap((tribe: Tribe) => tribe.tribeUsers || [])
                  .slice(0, 5)
                  .map((tribeUser: TribeUser, userIndex) => {
                    const firstName = tribeUser.user?.first_name;

                    if (
                      !tribeUser.user?.profile_pic ||
                      tribeUser.user?.profile_pic.startsWith("public")
                    ) {
                      return (
                        <div key={userIndex} className="">
                          <GradientProfile
                            size="md"
                            text={firstName?.charAt(0).toUpperCase() || "U"}
                          />
                        </div>
                      );
                    }

                    return (
                      <img
                        key={userIndex}
                        src={tribeUser.user?.profile_pic}
                        alt={`${firstName || `User ${userIndex + 1}`}`}
                        loading="lazy"
                        className="w-10 h-10 rounded-full border border-white object-cover"
                      />
                    );
                  })}
              </div>
              <div className="flex flex-col">
                <div>
                  <span className="text-primary-100 text-lg font-semibold pl-0.5">
                    {tribes?.length === 1
                      ? `${tribes?.length} Tribe`
                      : `${tribes?.length} Tribes`}
                  </span>
                </div>
                <div>
                  <span
                    className={classNames(
                      "text-primary-100 font-medium",
                      tribes &&
                        tribes?.flatMap(
                          (tribe: Tribe) => tribe.tribeUsers || []
                        ).length > 0
                        ? ""
                        : "pl-0.5"
                    )}
                  >
                    {tribes &&
                      tribes?.flatMap((tribe: Tribe) => tribe.tribeUsers || [])
                        .length > 0 &&
                      "+"}
                    {tribes
                      ?.flatMap((tribe: Tribe) => tribe.tribeUsers || [])
                      .length.toLocaleString()}{" "}
                    Attending
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hero_banner_slide">
          <div className="multi_genre_flx justify-content-end">
            <div className="share_btn d-none">
              <div className="share_btn_icon">
                <img src={ShareIcon} alt="ShareIcon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventBanner;
